// extracted by mini-css-extract-plugin
export default {"title":"caa-z","warning":"daa-z","sizeOptionsLegendText":"eaa-z"};